import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesWorkflowTransitionRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflow-transition',
	path: '/secure/admin/ViewWorkflowTransition.jspa',
};
